import { Col, Input, InputNumber, Row } from 'antd'
import Button from 'components/Button'
import styled from 'styled-components'
export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: ${props => props.style && '10px'};

  th {
    padding: 12px;
    text-align: left;
    font-weight: 500;
    font-size: 20px;
    border-bottom: 2px solid #ddd; /* General bottom border for all th */
  }

  th:nth-child(1) {
    /* Styling for the first <th> (Rule) */
    height: 57px;
    width: 399px;
    // background-color: rgba(240, 240, 240, 1);
    color: rgba(52, 62, 89, 1);
    border: 1px solid #ccc; /* Right border */
    border-left: 1px solid #ccc; /* Left border */
  }

  th:nth-child(2) {
    /* Styling for the second <th> (Details) */
    height: 57px;
    width: 597px;
    // background-color: rgba(240, 240, 240, 1);
    color: rgba(52, 62, 89, 1);
    border: 1px solid #bbb; /* Different right border */
  }

  th:nth-child(3) {
    /* Styling for the third <th> (Status) */
    height: 57px;
    width: 214px;
    // background-color: rgba(240, 240, 240, 1);
    color: rgba(52, 62, 89, 1);
    border: 1px solid #aaa; /* Different right border */
  }
  h3 {
    color: rgba(50, 73, 215, 1);
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
  }
  p {
    color: rgba(150, 150, 150, 1);
    font-size: 10px;
    font-weight: 500;
  }
  .head th {
    background-color: rgba(240, 240, 240, 1);
    color: rgba(52, 62, 89, 1);
  }
  .odd-row td {
    font-size: 16px;
    padding: 15px;
    display: flex;
    align-items:center;
  }
  span {
    color: rgba(50, 73, 215, 1);
    font-size: 16px;
    font-weight: 700;
    margin: 4px;
  }
  .even-row th {
    backgroun-color: white;
  }
  .Savebutton {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
  .Secondcolumn {
    font-size: 16px;
    font-weight: 500;
  }
  .odd-row {
    padding: 15px;
  }
  td.ctcthreshold {
    font-weight: 700;
  }
  .tableDetails {
    font-size: 16px;
    color: #000000;
    font-weight: 400;
  }
  .companyList {
    font-size: 16px;
    color: #000000;
  }
  .showBtn {
    font-size: 16px;
    font-weight: 600;
    border: none;
    background: none;
    outline: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;
  }
 .tableItem {
    height:181px,
    width:546px
    }
  .tableItem tr td {
    border: solid 1px  rgba(196, 196, 196, 1);
    border-collapse:collapse
  }
    .Applicationstatusthreshold
    {
    display:flex;
    flex-direction:column;
    }
`
export const SpanX = styled.div`
  font-weight: 700;
  cursor: pointer;
  font-size: 14px;
  color: ${props =>
    props?.disabled ? '#7C7C7C' : props.isOverwritten ? '#FF4C00' : '#000000'};
  padding-left: 10px;
  padding-right: 10px;
`
export const ClosePopup = styled.div`
  font-weight: 700;
  cursor: pointer;
  padding-left: 750px;
  margin-top: 30px;
`
export const ToggleButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 60px;
`
export const StyleRule = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
  gap: 10px;
  margin-bottom: 20px;
`
export const ArrowDiv = styled.div`
  cursor: pointer;
`
export const RulesTitle = styled.h3`
  color: ${props => (props.readOnly ? '#6B7280' : '#3249D7')}!important;
  cursor: ${props => (props?.readOnly ? 'default' : 'pointer')};
`

export const StyledRow = styled.tr`
  border-top: ${props => (props?.borderTop ? ' 1px solid #c4c4c4' : 'unset')};
  border-bottom: ${props =>
    props?.borderBottom ? ' 1px solid #c4c4c4' : 'unset'};
  border-left: 1px solid #c4c4c4;
  border-right: 1px solid #c4c4c4;
`

export const StyledTableData = styled.td`
  border-top: unset;
  border-bottom: unset;
  border-left: 1px solid #c4c4c4;
  border-right: 1px solid #c4c4c4;
  padding-top: ${props => (props?.firstData ? '30px' : '10px')};
  padding-bottom: ${props => (props?.lastData ? '30px' : '10px')};
  padding-left: 30px;
  padding-right: 30px;
`

export const TextElement = styled.p`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${props => (props?.disabled ? '#8A8A8A' : ' #1c1c1c')}!important;
  margin-top: ${props => (props?.mTop ? props?.mTop : 'inherit')};
`

export const TableDiv = styled.div`
  width: 100%;
`
export const StyledRuleHeader = styled('div')(() => ({
  display: 'flex',
  gap: '1rem',
  marginTop: '2rem',
  alignItems: 'center',
  marginBottom: 15,
}))

export const IconButton = styled('div')(() => ({
  cursor: 'pointer',
}))

export const RulesNavigationTitle = styled('div')(() => ({
  fontFamily: 'Plus Jakarta Sans',
  fontSize: 16,
  fontWeight: 600,
  '.description': {
    fontWeight: 400,
    color: '#7C7C7C',
    marginLeft: '0.5rem',
  },
}))

const getOrderBasedColor = orderNo => {
  switch (orderNo) {
    case 1:
      return {
        color: '#000000',
        borderColor: '#CCCCCC',
        background: '#FAFAFB',
      }
    case 2:
      return {
        color: '#000000',
        borderColor: '#97CADB',
        background: '#E0F7FF',
      }
    case 3:
      return {
        color: '#000000',
        borderColor: '#B5A3F7',
        background: '#E7E0FF',
      }

    case 4:
      return {
        color: '#000000',
        borderColor: '#E1A7BA',
        background: '#FFE5ED',
      }
    case 5:
      return {
        color: '#000000',
        borderColor: '#F29F05',
        background: '#F29F0533',
      }
    case 6:
      return {
        color: '#000000',
        borderColor: '#F25C05',
        background: '#F25C0533',
      }
    case 7:
      return {
        color: '#000000',
        borderColor: '#72B06F',
        background: '#72B06F33',
      }
    case 8:
      return {
        color: '#000000',
        borderColor: '#4C1D91',
        background: '#4C1D9133',
      }
    case 9:
      return {
        color: '#000000',
        borderColor: '#02457A',
        background: '#02457A33',
      }
    case 10:
      return {
        color: '#000000',
        borderColor: '#595F33',
        background: '#595F3333',
      }
    default:
      return {}
  }
}

export const StyledTextInput = styled(Input)`
  border-radius: 12px;
  width: ${props => props.width};
  height: ${props => props?.height};
  background: ${props => (props?.disabled ? '#FAFAFB' : '#FFFFFF')};
  border: ${props =>
    props?.disabled ? '1px solid #E6E7EA' : '1px solid #D6DBF7'};
  box-shadow: ${props =>
    props?.disabled ? 'unset' : ' 0px 2px 6px 0px #7b61ff26'};
  ${({ orderNo }) => {
    const { color, borderColor, background } = getOrderBasedColor(orderNo)
    return `
      color: ${color};
      border-color: ${borderColor};
      background: ${background};
    `
  }}
`

export const StyledInputNumber = styled(InputNumber)`
  border-radius: 12px;
  .ant-input-number-handler-wrap {
    display: none;
  }
  width: ${props => props.width};
  .ant-input-number-input {
    height: ${props => props?.height};
  }
  .ant-input-number {
    background: unset;
    width: ${props => props.width};
  }
`

export const StyledSymbolWithIcon = styled('span')`
  border-radius: 10px;
  width: ${props => props.width};
  height: ${props => props?.height};
  display: ${props => (props?.prefixWithIcon ? 'flex' : 'unset')};
  align-items: ${props => (props?.prefixWithIcon ? 'center' : 'unset')};
  justify-content: ${props => (props?.prefixWithIcon ? ' center' : 'unset')};
  gap: ${props => (props?.prefixWithIcon ? ' 1rem' : 'unset')};
  color: #8a8a8a;
`
export const ArrowLeft = styled.div`
  margin-top: 45px;
  cursor: pointer;
`

export const StyledRuleRow = styled(Row)(
  ({ pTop, pBottom, pLeft, pRight }) => ({
    paddingTop: pTop ? pTop : 'initial',
    paddingBottom: pBottom ? pBottom : 'initial',
    paddingLeft: pLeft ? pLeft : 'initial',
    paddingRight: pRight ? pRight : 'initial',
  })
)

export const StyledRuleCol = styled(Col)(
  ({ mTop, mBottom, mLeft, mRight }) => ({
    paddingTop: mTop ? mTop : 'initial',
    marginBottom: mBottom ? mBottom : 'initial',
    marginLeft: mLeft ? mLeft : 'initial',
    marginRight: mRight ? mRight : 'initial',
  })
)

export const NormalTable = styled('table')(() => ({
  th: {
    border: '1px solid #8A8A8A',
    background: '#F0F0F0',
    textAlign: 'left',
    padding: 12,
    p: {
      margin: 0,
      color: '#8A8A8A',
      fontFamily: 'Plus Jakarta Sans',
      fontSize: '14px',
      fontWeight: 600,
    },
  },
  width: '100%',
  marginTop: '10px',
  marginBottom: '10px',
  borderCollapse: 'collapse',
  td: {
    border: '1px solid #d9d9d9',
    padding: '10px 15px',
    gap: '2rem',
    color: '#8A8A8A',
  },
  '.tableData': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    gap: '2rem',
  },
}))

export const StyledHr = styled('hr')(() => ({
  border: 'none', // Remove the default border
  height: '1px', // Set the height of the line
  backgroundColor: '#d9d9d9', // Set the color you want (e.g., tomato)
  margin: '30px 0', // Example margin
}))

export const CheckBoxContainer = styled('div')(() => ({
  display: 'flex',
  gap: '1.2rem',
  whiteSpace: 'nowrap',
  flexDirection: 'column',
}))

export const RangeContainer = styled('div')(() => ({
  display: 'flex',
  gap: '1rem',
  marginBottom: '10px',
  alignItems: 'flex-start',
}))

export const RemoveListContainer = styled('div')(() => ({
  display: 'flex',
  marginBottom: 10,
}))

export const RemoveListItem = styled('div')(({ selected, isOverwritten }) => ({
  fontSize: 14,
  fontWeight: selected ? 700 : 400,
  color: selected ? '#3249D7' : isOverwritten ? '#FF4C00' : '#000000',
}))

export const SubTypoGraphy = styled('div')(() => ({
  fontSize: 14,
  fontWeight: 400,
  color: '#7D7D7D',
  paddingBottom: 7,
}))

export const StyledAddMoreBtn = styled(Button.Secondary)(() => ({
  height: 32,
  width: 115,
  background: '#F4F4FF',
  boxShadow: '0px 1px 2px 0px #1018280D',
  fontSize: 14,
  color: '#2563EB',
  borderRadius: 8,
  border: 'none',
  paddingLeft: 10,
  paddingRight: 10,
  ':hover': {
    background: '#F4F4FF',
  },
  ':focus': {
    background: '#F4F4FF',
  },
}))

export const NoteElement = styled('div')(({ warning, topSpacing }) => ({
  fontSize: 14,
  color: warning ? '#EB4335' : '#999FAC',
  paddingBottom: 7,
  marginBottom: 5,
  paddingTop: topSpacing || 'inherit',
}))

export const ButtonFooterContainer = styled.div`
  display: flex;
  justify-content: ${props => (props?.justify ? props?.justify : ' center')};
`

export const LevelBasedTable = styled('table')(() => ({
  marginTop: 20,
  width: '100%',
  '.tableData_text': {
    color: '#3249D7',
    fontWeight: 500,
    fontSize: 16,
  },
  td: {
    paddingTop: 5,
    paddingBottom: 5,
  },
}))
